import { Component, OnInit } from '@angular/core';

import { MainService } from 'app/resources/services/index';
import { MoedaUtils } from 'app/resources/utils/moeda-utils';

@Component({
  selector: 'app-extrato',
  templateUrl: './extrato.component.html'
})
export class ExtratoComponent implements OnInit {

  public transacaoSelecionada: any;
  public transacoes: any = undefined;
  public processando: boolean;

  constructor(public mainService: MainService) { }

  public selecionarTransacao(transacao) {
    this.transacaoSelecionada = transacao;
  };

  ngOnInit() {
    window.scrollTo(0, 0);
    this.mainService.saldoService.initialize();
    this.transacaoSelecionada = { origem: undefined };
    this.processando = true;

    this.mainService.http.pathRest().get('cartao/transacao/ultimas/', true)
      .subscribe(sucesso => {
        try {
          this.transacoes = sucesso.json();
          this.processando = false;
          this.selecionarTransacao(this.transacoes);
        } catch (err) {
          this.processando = false;
        }
      }, erro => {
        this.processando = false;
      });
  }

  public applyConversion(): number {
    return MoedaUtils.pontoToMoeda(this.mainService.saldoService.saldo.saldoPontos, this.mainService.cartaoService.cartao.indiceMoeda);
  }

}



// WEBPACK FOOTER //
// ./src/app/extrato/extrato.component.ts